module.exports = __webpack_public_path__ + "static/media/NESO.69ed7655.svg";